import { HButton } from "@components/Button"
import { HDialog } from "@components/Dialog"
import { Input } from "@components/Input";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { FormControl, Grid } from "@mui/material";
import { LabelControl } from "@shared/styledComponents";
import { useEffect, useState } from "react";
import AddIcon from '@mui/icons-material/Add';
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';
import { storeOpenSnackbar, storeSetGlobalLoading } from "@store/globalReducer";
import { useDispatch } from "react-redux";
import { ApiConfig } from "@config/index";
import { apiClient } from "@services/baseAxios";
import { errorMessages } from "@shared/constants/messages";

export const LocationForm = ({ title, isOpen, locationData, handleOnClose, handleOnConfirm, isCreateNew }: any) => {
    const dispatch = useDispatch();
    const [location, setLocation] = useState({} as any);

    const handleTextInputChange = (event: any, field: string) => {
        const value = event.target.value;
        switch (field) {
            case 'name':
                setLocation((prevState: any) => ({
                    ...prevState,
                    ...{ Name: value }
                }));
                break;
            case 'code':
                setLocation((prevState: any) => ({
                    ...prevState,
                    ...{ Code: value }
                }));
                break;
            case 'address':
                setLocation((prevState: any) => ({
                    ...prevState,
                    ...{ Address: value }
                }));
                break;
        }
    }

    const handleSubmit = () => {
        if (isCreateNew) {
            createLocation();
        }
        else {
            updateLocation();
        }
    }

    const createLocation = async () => {
        if (!location.Name || !location.Code || !location.Address) {
            dispatch(storeOpenSnackbar({ open: true, message: "Vùi lòng nhập đủ thông tin", type: "warning" }));
            return;
        }

        try {
            dispatch(storeSetGlobalLoading(true));
            var { AppCode } = await apiClient.post(`${ApiConfig.LOCAION}`, location);
            dispatch(storeSetGlobalLoading(false));
            if (AppCode === 200) {
                handleOnConfirm();
            }
            else {
                dispatch(storeOpenSnackbar({ open: true, message: errorMessages.SYSTEM_ERROR, type: "error" }));
            }
        } catch (error: any) {
            dispatch(storeSetGlobalLoading(false));
            if (error?.response?.data?.AppCode === 500) {
                dispatch(storeOpenSnackbar({ open: true, message: error?.response?.data?.Message, type: "error" }));
            }
            else if (error?.response?.data?.AppCode === 400) {
                dispatch(storeOpenSnackbar({ open: true, message: "Thông tin đẩy lên sai định dạng", type: "error" }));
            }
            else {
                dispatch(storeOpenSnackbar({ open: true, message: errorMessages.SYSTEM_ERROR, type: "error" }));
            }
        }
    }

    const updateLocation = async () => {
        if (!location.Name || !location.Code || !location.Address) {
            dispatch(storeOpenSnackbar({ open: true, message: "Vùi lòng nhập đủ thông tin", type: "warning" }));
            return;
        }

        try {
            dispatch(storeSetGlobalLoading(true));
            var { AppCode } = await apiClient.put(`${ApiConfig.LOCAION}/${location.Id}`, location);
            dispatch(storeSetGlobalLoading(false));
            if (AppCode === 200) {
                handleOnConfirm();
            }
            else {
                dispatch(storeOpenSnackbar({ open: true, message: errorMessages.SYSTEM_ERROR, type: "error" }));
            }
        } catch (error: any) {
            dispatch(storeSetGlobalLoading(false));
            if (error?.response?.data?.AppCode === 500) {
                dispatch(storeOpenSnackbar({ open: true, message: error?.response?.data?.Message, type: "error" }));
            }
            else if (error?.response?.data?.AppCode === 400) {
                dispatch(storeOpenSnackbar({ open: true, message: "Thông tin đẩy lên sai định dạng", type: "error" }));
            }
            else {
                dispatch(storeOpenSnackbar({ open: true, message: errorMessages.SYSTEM_ERROR, type: "error" }));
            }
        }
    }

    useEffect(() => {
        setLocation(locationData || {});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <HDialog
            PaperProps={{
                sx: {
                    width: "450px",
                }
            }}
            title={title}
            open={isOpen}
            handleClose={handleOnClose}
            dialogFooter={
                <>
                    <HButton startIcon={<CloseOutlinedIcon />} btnType="secondary" onClick={handleOnClose}>Hủy</HButton>
                    {
                        isCreateNew ?
                            <HButton startIcon={<AddIcon />} onClick={handleSubmit}>Tạo cơ sở</HButton>
                            :
                            <HButton startIcon={<DoneOutlinedIcon />} onClick={handleSubmit}>Lưu</HButton>
                    }
                </>
            }
        >
            <Grid container>
                <Grid sx={{ pt: 0, pl: 0 }} item xs={12}>
                    <FormControl sx={{ width: '100%' }} variant="standard">
                        <LabelControl required>Tên</LabelControl>
                        <Input onChange={(event: any) => handleTextInputChange(event, 'name')} value={location.Name} sx={{ width: '100%', marginTop: '4px' }} placeholder="Nhập tên cơ sở" />
                    </FormControl>
                </Grid>
                <Grid sx={{ pt: 0, pl: 0, marginTop: '16px' }} item xs={12}>
                    <FormControl sx={{ width: '100%' }} variant="standard">
                        <LabelControl required>Mã</LabelControl>
                        <Input onChange={(event: any) => handleTextInputChange(event, 'code')} value={location.Code} sx={{ width: '100%', marginTop: '4px' }} placeholder="Nhập mã cơ sở" />
                    </FormControl>
                </Grid>
                <Grid sx={{ pt: 0, pl: 0, marginTop: '16px' }} item xs={12}>
                    <FormControl sx={{ width: '100%' }} variant="standard">
                        <LabelControl required>Địa chỉ</LabelControl>
                        <Input onChange={(event: any) => handleTextInputChange(event, 'address')} value={location.Address} sx={{ width: '100%', marginTop: '4px' }} placeholder="Nhập địa chỉ cơ sở" />
                    </FormControl>
                </Grid>
            </Grid>
        </HDialog>
    )
}